import Link from "next/link";
import { useId, type ComponentProps } from "react";

const NEW_TAB_ANNOUNCEMENT = "Opens in a new tab.";

type ArticleLinkProps = Omit<
    ComponentProps<typeof Link>,
    "target" | "rel"
>;

/**
 * Link to an individual Iloris article.
 *
 * Article destinations intentionally open beside the product flow that sent
 * someone there. Keeping the behavior here makes the security attributes and
 * screen-reader announcement impossible for callers to omit.
 */
export function ArticleLink({
    children,
    "aria-describedby": ariaDescribedBy,
    ...props
}: ArticleLinkProps) {
    const descriptionId = useId();

    return (
        <>
            <Link
                {...props}
                aria-describedby={
                    ariaDescribedBy
                        ? `${ariaDescribedBy} ${descriptionId}`
                        : descriptionId
                }
                target="_blank"
                rel="noopener noreferrer"
            >
                {children}
            </Link>
            <span id={descriptionId} className="sr-only">
                {NEW_TAB_ANNOUNCEMENT}
            </span>
        </>
    );
}
